import { UrlApi } from "../../../../../services/apirest";

export const traerCantidadDeNotasEnvasado = async (idCliente) => {
  const response = await fetch(
    `${UrlApi}/cuentaCorriente/notas/count/${idCliente}/1`,
  );
  if (!response.ok)
    throw new Error(
      "Ocurrio un error al traer la cantidad de notas de envasado",
    );

  return await response.json();
};
